let Backbone = require("backbone");
import i18n from "../utils/i18n";

let POS = require("../POS.js");

let main = function (Backbone, i18n, POS) {
    return Backbone.View.extend({
        el: "#screenAlertModal",

        initialize: function () {
        },

        _text: function (text) {
            this.$(".modal-body p").html(text).css("text-align", "center");
            return this;
        },


        render: function (leftDays) {
            console.log("left days =", this.model.get("licenseRemainsDays"));
            if (leftDays == 0) {
                this._text("你的账户已到期,请联系客服.客服电话:027-8282 2869").$el.modal("show");
            } else {
                this._text(i18n.msg("pos.alert.license.expiry", ' ' + this.model.get("licenseRemainsDays") + ' ')).$el.modal("show");
            }
        }


    });

};

export default main(Backbone, i18n, POS);




// WEBPACK FOOTER //
// ./src/view/LicenseCheckView.js